//客户管理路由文件
export default [
  {
    //用户管理
    path: '/clientUserManage',
    component: resolve => require(['../pages/clientManage/userManage/userManage.vue'], resolve),
    name: 'clientUserManage',
    title: "用户管理",
    meta: {
      title: "用户管理"
    }
  },
  {
    //家庭管理
    path: '/ownerManage',
    component: resolve => require(['../pages/clientManage/ownerManage/ownerManage.vue'], resolve),
    name: 'ownerManage',
    title: "家庭管理",
    meta: {
      title: "家庭管理"
    }
  },
  {
    //标签数据
    path: '/tagDataManage',
    component: resolve => require(['../pages/clientManage/tagDataManage/tagDataManage.vue'], resolve),
    name: 'tagDataManage',
    title: "标签数据",
    meta: {
      title: "标签数据"
    }
  },
  {
    //用户分群
    path: '/segmentManage',
    component: resolve => require(['../pages/clientManage/segmentManage/segmentManage.vue'], resolve),
    name: 'segmentManage',
    title: "用户分群",
    meta: {
      title: "用户分群"
    }
  },
  {
    //业主数据
    path: '/proprietorData',
    component: resolve => require(['../pages/clientManage/proprietorData/proprietorData.vue'], resolve),
    name: 'proprietorData',
    title: "业主数据",
    meta: {
      title: "业主数据"
    }
  }
]
